export default __webpack_public_path__ + "static/media/portfolio__foto.e8a37a46.jpg";